import React from "react";
import styles from "./PostListing.module.css"
import Link from "gatsby-link"
import FontIcon from "react-md/lib/FontIcons";
import Img from "gatsby-image"


class PostListing extends React.Component {
  getPostList() {
    const postList = [];
    if (this.props.data == null) { return postList}
    this.props.data.edges.forEach(postEdge => {
          let queriedImage = {}
          if(postEdge.node.frontmatter.image != null){
            queriedImage = postEdge.node.frontmatter.image.childImageSharp.fluid
          }

          postList.push({
           title: postEdge.node.frontmatter.title,
           date: postEdge.node.frontmatter.date,
           id: postEdge.node.id,
           slug: postEdge.node.fields.slug,
           author: postEdge.node.frontmatter.author,
           category: postEdge.node.frontmatter.categories,
           excerpt: postEdge.node.excerpt,
           image: queriedImage,
          });
        });
    return postList;
  }
  render() {
    const postList = this.getPostList();
    return ( <div>
      {postList.map((post,id) =>
          <div key={post.id} className={styles.indexBorderContainer}>
          <h4>
            <span>
            <Link to={`/authors/${post.author}`}>
                     {post.author}</Link> on {post.date}
            </span>
          </h4>
            <Link to={post.slug}>
                <h1>
                    {post.title}{" "}
                </h1>
            </Link>

            <div>
             <Link to={post.slug}>
                <Img className={styles.headerImage} fluid={post.image} />
              </Link>
            </div>

            <p>
                {post.excerpt}
            </p>
            <p className={styles.noMarginBottom}>
               <Link to={post.slug}>
                <strong className={styles.readMore}>Read More</strong>
                <FontIcon iconClassName="fa fa-long-arrow-right" />
               </Link>
           </p>
          </div>
      )}
      </div>
    )
  }
}
export default PostListing;
